let mobile = window.matchMedia("(max-width: 480px)").matches;
let product_form = document.querySelector('#main-prodct-form');
const atc_btn = document.querySelector("product-form .product-from__row") || false;

if (mobile && atc_btn){
    let timeout;
    const addStickyClass = () => { 
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            ;
            const rect = atc_btn?.getBoundingClientRect();
            const product_form_rect = product_form.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > rect.top / 2 && product_form_rect.bottom > 0) {
                atc_btn.classList.remove("sticky");
                if (document.querySelector('#to-top')) document.querySelector('#to-top').style.display = 'block'; 

                if (document.getElementById('gorgias-chat-container') ){ 
                  document.getElementById('gorgias-chat-container').style.display = 'block';
                }
              } else {
                atc_btn.classList.add("sticky"); // hide back to top btn
                if (document.querySelector('#to-top')) document.querySelector('#to-top').style.display = 'none';

                if (document.getElementById('gorgias-chat-container')){  // if chat appeared - hide it 
                  document.getElementById('gorgias-chat-container').style.display = 'none';
                }
              }
        }, 100); // Adjust the delay as needed
    }


  window.addEventListener("scroll", addStickyClass);
} 